import { type ReactNode, useId } from "react";

import { cn } from "@/shared/lib";

type DashboardCardProps = {
  title: ReactNode;
  // Откуда цифры или как их читать — под заголовком.
  description?: ReactNode;
  // Легенда или переключатель справа от заголовка.
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
};

// Карточка блока дашборда: заголовок, подпись, справа — легенда или переключатель.
export const DashboardCard = ({
  title,
  description,
  aside,
  className,
  children,
}: DashboardCardProps) => {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        "flex min-w-0 flex-col gap-3.5 rounded-[14px] border border-border bg-surface px-5 pt-4.5 pb-5",
        className,
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-5 gap-y-2">
        <div className="flex flex-col gap-0.5">
          <h2 id={headingId} className="text-[17px] font-semibold">
            {title}
          </h2>
          {description !== undefined && <p className="text-[13px] text-subtle">{description}</p>}
        </div>
        {aside}
      </div>
      {children}
    </section>
  );
};
